import { useMemo } from 'react';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18nCountries from 'i18n-iso-countries';
import EN_COUNTRIES from 'i18n-iso-countries/langs/en.json';
import NL_COUNTRIES from 'i18n-iso-countries/langs/nl.json';
import FR_COUNTRIES from 'i18n-iso-countries/langs/fr.json';
import { initReactI18next, useTranslation } from 'react-i18next';
import nl from './nl.json';
import fr from './fr.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'nl',

    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
  });

i18nCountries.registerLocale({ ...EN_COUNTRIES, locale: 'en-gb' });
i18nCountries.registerLocale({ ...EN_COUNTRIES, locale: 'en-us' });
i18nCountries.registerLocale(EN_COUNTRIES);
i18nCountries.registerLocale(NL_COUNTRIES);
i18nCountries.registerLocale(FR_COUNTRIES);

const useLanguage = () => {
  const { i18n } = useTranslation();
  return useMemo<any>(() => i18n.language.split('-')[0] || (i18n.options?.fallbackLng as string[])[0], [i18n]);
};

export { useLanguage, i18n };
